"use strict";exports.GRAPHQL_URL_PATH="services.predictionStorageService.graphqlUri";